<template>
  <div class="auth-page md-layout md-alignment-center-center">
    <md-card class="auth-page__card">

      <md-card-header>
        <div class="text_xl_large">{{i18n.lbl_almost_done()}}</div>
      </md-card-header>

      <md-card-content>

        <p class="text_small">{{i18n.lbl_confirmation_sent({mail: email})}}</p>
        <p class="text_small">{{i18n.lbl_check_spam()}}</p>

        <div class="btn-wrap margin-top">
          <md-button @click="requestNew"
                     class="btn md-primary"
                    :disabled="isButtonDisabled">
            {{i18n.lbl_request_new_email() }}
          </md-button>
        </div>

      </md-card-content>
    </md-card>
  </div>
</template>

<script>
  import form from '@com/mixins/form.mixin'
  import { i18n } from '@js/i18n'
  import { EventDispatcher } from '@js/events/event_dispatcher'
  import { emailService } from '@api/email.service'

  export default {
    name: 'email-resend',

    mixins: [form],

    data () {
      return {
        walletId: '',
        email: '',
        i18n
      }
    },

    created () {
      this.walletId = this.$route.query.walletId
      this.email = this.$route.query.email
    },

    methods: {
      async requestNew () {
        this.disable()
        try {
          await emailService.sendResendEmailRequest(this.walletId)
          EventDispatcher.dispatchShowSuccessEvent('Request successfully sent. Please check your inbox')
        } catch (error) {
          console.error(error)
          EventDispatcher.dispatchShowErrorEvent('Email already confirmed')
        }
        this.enable()
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import 'auth';
</style>



// WEBPACK FOOTER //
// src/vue/auth/ConfirmEmail.vue